// Module-level bridge that lets non-component code (e.g. the useApiMutation hook,
// or plain async utilities) trigger the global alert without prop-drilling or
// pulling in React context. The AlertProvider registers its setAlert on mount so
// there's a single source of truth: the same Snackbar the 48 existing
// `useAlert()` call sites already drive.
//
// If nothing is registered yet (e.g. an alert fires before the provider mounts,
// or in a test), notify() is a safe no-op.

let alertHandler = null;

/**
 * registerAlertHandler — called by AlertProvider to wire its setAlert here.
 * Returns an unregister function so the provider can clean up on unmount and we
 * never hold a stale handler across HMR reloads.
 */
export const registerAlertHandler = (handler) => {
  alertHandler = typeof handler === 'function' ? handler : null;
  return () => {
    if (alertHandler === handler) alertHandler = null;
  };
};

/**
 * notify — show a global alert from anywhere. severity is one of
 * 'success' | 'error' | 'warning' | 'info' (matches MUI Alert + AlertContext).
 * No-ops silently when no handler is registered.
 */
export const notify = (message, severity = 'info') => {
  if (!message || !alertHandler) return;
  alertHandler(message, severity);
};
